<script lang="ts">
  import NotesReturnOfTerminalAdapterParts from '../parts/NotesReturnOfTerminalAdapterParts.svelte';
  import type { SubContractHikari01TelResult } from '../../../../repositories/subcontracthikari01tel';

  export let hikari01Tel!: SubContractHikari01TelResult;
  export let handleConfirmEvent!: any;

  const handleConfirm = (): void => {
    handleConfirmEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">GateCall(F) / GateCall(M) の解約について</h1>
    </div>
  </div>
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>■電話番号の取り扱い</p>
          <p class="mt-4 ml-4">
            現在利用いただいている電話番号：{hikari01Tel.hikari01TelNumber}
          </p>
          <ul class="list-disc mt-4 ml-8">
            <li>
              <p>上記電話番号は、本解約手続きにより以降利用できなくなります</p>
            </li>
            <li>
              <p>当該電話番号は番号ポータビリティの手続きはできません</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="inline-flex justify-items-center items-center min-w-full mt-6">
        <div class="mb:font-sm w-full">
          <p>■レンタル機器の取り扱い</p>
          <ul class="list-none ml-4">
            <li>
              <p>
                でんわの利用の際に使用している専用のターミナルアダプタ等については、<span class="warning"
                  >解約月翌月20日必着</span
                >でご返却いただく必要があります。
              </p>
            </li>
            <li>
              <p>
                期日までの返却が確認できない場合、<span class="warning">弁済費(21,000円)</span
                >が必要となりますのでご注意ください
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ターミナルアダプタの返却先 -->
    <NotesReturnOfTerminalAdapterParts />

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  p > span.warning {
    @apply font-semibold text-red-400;
  }

  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
